import { Check, X as XIcon, Minus } from 'lucide-react'
import '../../workspace/css/workspace.scss'

const PassIcon = ({ result }) => {
  if (result === true) return <div className="ws-test-icon ws-test-icon-passed"><Check className="ws-icon-md" /></div>
  if (result === false) return <div className="ws-test-icon ws-test-icon-failed"><XIcon className="ws-icon-md" /></div>
  return <div className="ws-test-icon ws-test-icon-pending"><Minus className="ws-icon-md" /></div>
}

export default function ReplayTestCases({ testResults = [], testCases = [], title = 'Test Cases' }) {
  // testCases comes from formatTestsForRender(session, []) — has { testName, result }
  // testResults comes from useReplayState — has { test_case_number, passed }

  const tests = testCases.length > 0
    ? testCases.map((tc, index) => {
        // Match with replay test results if available. formatTestsForRender lists public
        // tests first, so match by the row's place in test_list (tc.index), not this one.
        const replayResult = testResults[tc.index ?? index]
        return {
          name: tc.testName || `Test Case ${index + 1}`,
          result: replayResult?.passed ?? tc.result ?? null,
        }
      })
    : testResults.length > 0
      ? testResults.map((test, index) => ({
          name: `Test Case ${test.test_case_number || index + 1}`,
          result: test.passed,
        }))
      : [
          { name: 'Test Case 1', result: null },
          { name: 'Test Case 2', result: null },
          { name: 'Test Case 3', result: null },
        ]

  return (
    <div className="ws-content-section">
      <h3 className="ws-section-title">{title}</h3>
      <div className="ws-test-table-wrapper">
        <table className="ws-test-table">
          <thead>
            <tr>
              <th>Name</th>
              <th className="ws-result-column">Result</th>
            </tr>
          </thead>
          <tbody>
            {tests.map((test, index) => (
              <tr key={index}>
                <td>{test.name}</td>
                <td className="ws-result-column">
                  <PassIcon result={test.result} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}